import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "The Day The Earth Stood Still",
  date: new Date(2025, 5, 15),
  img: "/img/father.jpeg",
  tracks: [
    {
      title: "Bowling Shoes",
      src: "/songs/2025-06-15/bowling_shoes.mp3",
      duration: 614.064,
    },
    {
      title: "Deconstruction",
      src: "/songs/2025-06-15/deconstruction.mp3",
      duration: 670.632,
    },
    {
      title: "Tempotation",
      src: "/songs/2025-06-15/tempotation.mp3",
      duration: 884.568,
    },
    {
      title: "Angry Mosquito",
      src: "/songs/2025-06-15/angry_mosquito.mp3",
      duration: 688.416,
    },
    {
      title: "Jurassic Zoo",
      src: "/songs/2025-06-15/jurassic_zoo.mp3",
      duration: 598.32,
    },
    {
      title: "Conference Call",
      src: "/songs/2025-06-15/conference_call.mp3",
      duration: 484.992,
    },
    {
      title: "Rabbit Hole",
      src: "/songs/2025-06-15/rabbit_hole.mp3",
      duration: 563.184,
    },
    {
      title: "Mess Around (And Find Out)",
      src: "/songs/2025-06-15/mess_around.mp3",
      duration: 843.552,
    },
    {
      title: "Under Pressure",
      src: "/songs/2025-06-15/under_pressure.mp3",
      duration: 527.688,
    },
    {
      title: "Stay Where You Are",
      src: "/songs/2025-06-15/stay_where_you_are.mp3",
      duration: 579.024,
    },
    {
      title: "Inchworm",
      src: "/songs/2025-06-15/inchworm.mp3",
      duration: 555.12,
    },
    {
      title: "Rama Lama Slama Jam",
      src: "/songs/2025-06-15/rama_lama_slama_jam.mp3",
      duration: 333.96,
    },
    {
      title: "Covert Town",
      src: "/songs/2025-06-15/covert_town.mp3",
      duration: 1037.424,
    },
    {
      title: "What About Me?!",
      src: "/songs/2025-06-15/what_about_me.mp3",
      duration: 513.36,
    },
    {
      title: "There's Always A Tomorrow",
      src: "/songs/2025-06-15/theres_always_a_tomorrow.mp3",
      duration: 670.584,
    },
    {
      title: "It's Not Over",
      src: "/songs/2025-06-15/its_not_over.mp3",
      duration: 651,
    },
    {
      title: "Father's Day Jam",
      src: "/songs/2025-06-15/fathers_day_jam.mp3",
      duration: 936.504,
    },
  ],
};
export default album;
